<template>
    <div>
      <common-list
        ref="list"
        url="WeighingScrap/GetList"
        @currentrow="handlerCurrentRow"
      >
        <!-- 条件区域 -->
        <template v-slot:filter="{ filter }">
          <el-col :span="6">
          <el-form-item label="物料名称" prop="ScrapName">
            <el-input
              v-model.trim="filter.ScrapName"
              placeholder="物料名称" 
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        </template>
        <!-- 按钮区域 -->
        <template v-slot:option>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="add"
            v-if="auth('WeighingScrapAdd')"
            >添加</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click="edit"
            v-if="auth('WeighingScrapEdit')"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteItem"
            v-if="auth('WeighingScrapDelete')"
            >删除</el-button
          >
          <el-button 
            type="blue" 
            icon="el-icon-tickets" 
            @click="show"
            v-if="auth('WeighingScrapShow')"
            >查看</el-button
          >
        </template>
        <!-- 展示区域 -->
        <template v-slot:body>
          <el-table-column
            label="物料编号"
            prop="ScrapNumber"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="物料名称"
            prop="ScrapName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="数量"
            prop="ScrapNum"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="重量(KG)" 
            prop="Weight" 
            show-overflow-tooltip>
          </el-table-column>
          
          <el-table-column label="司磅员" 
            prop="Weigher" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="称重日期" 
            prop="WeightingTime" 
            show-overflow-tooltip>
          </el-table-column>
        </template>
      </common-list>
      <!-- 弹窗区域 Show -->
      <div>
        <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
        <Showdialog :item="itemShow"></Showdialog>
      </div>
    </div>
  </template>
  
  <script>
  import AddEdit from "./AddEdit";
  import Showdialog from "./Show";
  export default {
    components: {
        AddEdit,
        Showdialog
    },
    data() {
      return {
        itemAddEdit: {},
        itemShow:{},
        showitem: [],
      };
    },
    computed: {

    },
    mounted() {
     
    },
    methods: {
      getData() {
        this.$refs.list.getTableData();
      },
      add() {
        this.itemAddEdit = {};
      },
      edit() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemAddEdit = { KeyId: this.currentrow.KeyId };
      },
      deleteItem() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.$confirm(
          `将删除物料名称为【${this.currentrow.ScrapName}】的物料称重信息, 是否继续?`,
          "提示信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "el-button--canale",
            type: "warning",
          }
        )
          .then(() => {
            this.$delete("WeighingScrap/Delete", {
              KeyId: this.currentrow.KeyId,
            }).then(() => {
              this.$message.success("删除成功");
              this.$refs.list.getTableData();
            });
          })
          .catch(() => {});
      },
      show() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemShow = { KeyId: this.currentrow.KeyId };
       
      },
    },
  };
  </script>
  
  <style>
  </style>